// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2WB9K","noInteraction":"EventWrapper_noInteraction__2X-EN","pointerPassthrough":"EventWrapper_pointerPassthrough__1MIsz"};